module.exports = __webpack_public_path__ + "img/kf.848090f1.png";